module.exports = __webpack_public_path__ + "static/media/twenty_off.eea36794.svg";